/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateSimulationResponseDto
 */
export interface CreateSimulationResponseDto {
    /**
     * 
     * @type {string}
     * @memberof CreateSimulationResponseDto
     */
    riskId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSimulationResponseDto
     */
    folderIdentifier: string;
}

/**
 * Check if a given object implements the CreateSimulationResponseDto interface.
 */
export function instanceOfCreateSimulationResponseDto(value: object): value is CreateSimulationResponseDto {
    if (!('riskId' in value) || value['riskId'] === undefined) return false;
    if (!('folderIdentifier' in value) || value['folderIdentifier'] === undefined) return false;
    return true;
}

export function CreateSimulationResponseDtoFromJSON(json: any): CreateSimulationResponseDto {
    return CreateSimulationResponseDtoFromJSONTyped(json, false);
}

export function CreateSimulationResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSimulationResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'riskId': json['riskId'],
        'folderIdentifier': json['folderIdentifier'],
    };
}

export function CreateSimulationResponseDtoToJSON(json: any): CreateSimulationResponseDto {
    return CreateSimulationResponseDtoToJSONTyped(json, false);
}

export function CreateSimulationResponseDtoToJSONTyped(value?: CreateSimulationResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'riskId': value['riskId'],
        'folderIdentifier': value['folderIdentifier'],
    };
}

